export class HoldingConfig {
	// TODO: move all the colors to variable
	public static readonly MUTUALFUND_ETF = [
		{
			name: 'MUTUAL FUNDS',
			isParent: true,
			isSummation: true,
			includedAsEmpty: true,
			values: ['ASSET_LEGAL_TYPE_CLOSED_END', 'ASSET_LEGAL_TYPE_OPEN_END', 'ASSET_LEGAL_TYPE_STIF'],
			attributes: { colorTheme: '#006BB4' }
		},
		{
			name: 'ETFs',
			isParent: true,
			isSummation: true,
			includedAsEmpty: true,
			values: ['ASSET_LEGAL_TYPE_ETF'],
			attributes: { colorTheme: '#68A230' }
		}
	];

	public static readonly MUTUALFUND_ETF_PAS_PORTFOLIO_ANALYSIS = [
		{
			name: 'MUTUAL FUNDS',
			isParent: true,
			isSummation: true,
			includedAsEmpty: true,
			values: ['FC', 'FO', 'FM'],
			attributes: { colorTheme: '#006BB4' }
		},
		{
			name: 'ETFs',
			isParent: true,
			isSummation: true,
			includedAsEmpty: true,
			values: ['FE'],
			attributes: { colorTheme: '#68A230' }
		}
	];

	public static readonly FUNDS = [
		{
			name: 'FUNDS',
			isParent: true,
			isSummation: true,
			includedAsEmpty: true,
			values: ['ASSET_LEGAL_TYPE_CLOSED_END', 'ASSET_LEGAL_TYPE_OPEN_END', 'ASSET_LEGAL_TYPE_STIF', 'ASSET_LEGAL_TYPE_ETF'],
			attributes: { colorTheme: '#68A230' }
		}
	];

	public static readonly SINGLE_STOCKS = [
		{
			name: 'SINGLE STOCKS',
			isParent: true,
			isSummation: true,
			includedAsEmpty: true,
			values: ['ASSET_TYPE_STOCK'],
			attributes: { colorTheme: '#006BB4' }
		}
	];

	public static readonly IQ_MUTUAL_ETF_FUNDS_COUNT = [
		{
			name: 'Mutual Funds',
			values: ['ASSET_LEGAL_TYPE_CLOSED_END', 'ASSET_LEGAL_TYPE_OPEN_END', 'ASSET_LEGAL_TYPE_STIF'],
			attributes: { colorTheme: '#0AAD73' }
		},
		{
			name: 'ETFs',
			values: ['ASSET_LEGAL_TYPE_ETF'],
			attributes: { colorTheme: '#CDF8E4' }
		}
	];
}
